import { createParser } from "nuqs";
import { ListViewColumn } from "../../queries/getCrmCustomListViews";
import { parseEnum, parseObjectInQueryString, validateNumber } from "./nuqsHelperFunctions";
import { FieldTypeOptions } from "../../schemas/DemoTypes";

export const nuqsColumnFieldParser = createParser<ListViewColumn>({
  parse(value) {
    const parsedObject = parseObjectInQueryString({
      queryString: value,
      keyValueSeparator: "|",
      pairSeparator: "::",
    });
    const preValidatedColumnFieldObject = {
      fieldName: parsedObject.fieldName,
      fieldId: parsedObject.fieldId,
      fieldType: parsedObject.fieldType,
      order: parsedObject.order,
    };
    if (!preValidatedColumnFieldObject.fieldName || !preValidatedColumnFieldObject.order) {
      return null;
    }

    const validatedOrder = validateNumber(preValidatedColumnFieldObject.order);
    if (!validatedOrder) {
      return null;
    }
    const validatedFieldType = parseEnum(preValidatedColumnFieldObject.fieldType, FieldTypeOptions);
    if (!validatedFieldType) {
      return null;
    }
    return {
      fieldName: preValidatedColumnFieldObject.fieldName,
      fieldId: validateNumber(preValidatedColumnFieldObject.fieldId),
      fieldType: validatedFieldType,
      order: validatedOrder,
    };
  },
  serialize(value) {
    return `fieldName::${value.fieldName}|fieldId::${value.fieldId}|order::${value.order}|`;
  },
});
